/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  Customer,
  RegistrationFinish,
  RegistrationStart,
  VerificationCode,
  VerificationRequest,
  VerificationResponse,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    CustomerFromJSON,
    CustomerToJSON,
    RegistrationFinishFromJSON,
    RegistrationFinishToJSON,
    RegistrationStartFromJSON,
    RegistrationStartToJSON,
    VerificationCodeFromJSON,
    VerificationCodeToJSON,
    VerificationRequestFromJSON,
    VerificationRequestToJSON,
    VerificationResponseFromJSON,
    VerificationResponseToJSON,
} from '../models';

export interface FinishCustomerRegistrationRequest {
    xApplicationScope: ApplicationScope;
    verificationRequestId: string;
    registrationFinish: RegistrationFinish;
}

export interface RegisterCustomerRequest {
    xApplicationScope: ApplicationScope;
    registrationStart: RegistrationStart;
}

export interface ResendVerificationCodeRequest {
    xApplicationScope: ApplicationScope;
    verificationRequestId: string;
}

export interface VerifyCustomerRequest {
    xApplicationScope: ApplicationScope;
    verificationRequestId: string;
    verificationCode: VerificationCode;
}

/**
 * 
 */
export class RegistrationControllerApi extends runtime.BaseAPI {

    /**
     * finish an ongoing customer registration
     * finish new customer registration
     */
    async finishCustomerRegistrationRaw(requestParameters: FinishCustomerRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling finishCustomerRegistration.');
        }

        if (requestParameters.verificationRequestId === null || requestParameters.verificationRequestId === undefined) {
            throw new runtime.RequiredError('verificationRequestId','Required parameter requestParameters.verificationRequestId was null or undefined when calling finishCustomerRegistration.');
        }

        if (requestParameters.registrationFinish === null || requestParameters.registrationFinish === undefined) {
            throw new runtime.RequiredError('registrationFinish','Required parameter requestParameters.registrationFinish was null or undefined when calling finishCustomerRegistration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/registration/{verificationRequestId}/finish`.replace(`{${"verificationRequestId"}}`, encodeURIComponent(String(requestParameters.verificationRequestId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegistrationFinishToJSON(requestParameters.registrationFinish),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * finish an ongoing customer registration
     * finish new customer registration
     */
    async finishCustomerRegistration(requestParameters: FinishCustomerRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.finishCustomerRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * start registration process for new customer
     * start registration process for new customer
     */
    async registerCustomerRaw(requestParameters: RegisterCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerificationRequest>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling registerCustomer.');
        }

        if (requestParameters.registrationStart === null || requestParameters.registrationStart === undefined) {
            throw new runtime.RequiredError('registrationStart','Required parameter requestParameters.registrationStart was null or undefined when calling registerCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/registration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegistrationStartToJSON(requestParameters.registrationStart),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerificationRequestFromJSON(jsonValue));
    }

    /**
     * start registration process for new customer
     * start registration process for new customer
     */
    async registerCustomer(requestParameters: RegisterCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerificationRequest> {
        const response = await this.registerCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * send verification code to customer
     * send verification code to customer
     */
    async resendVerificationCodeRaw(requestParameters: ResendVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerificationRequest>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling resendVerificationCode.');
        }

        if (requestParameters.verificationRequestId === null || requestParameters.verificationRequestId === undefined) {
            throw new runtime.RequiredError('verificationRequestId','Required parameter requestParameters.verificationRequestId was null or undefined when calling resendVerificationCode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/registration/{verificationRequestId}/resend`.replace(`{${"verificationRequestId"}}`, encodeURIComponent(String(requestParameters.verificationRequestId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerificationRequestFromJSON(jsonValue));
    }

    /**
     * send verification code to customer
     * send verification code to customer
     */
    async resendVerificationCode(requestParameters: ResendVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerificationRequest> {
        const response = await this.resendVerificationCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * verify new customer
     * verify new customer
     */
    async verifyCustomerRaw(requestParameters: VerifyCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerificationResponse>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling verifyCustomer.');
        }

        if (requestParameters.verificationRequestId === null || requestParameters.verificationRequestId === undefined) {
            throw new runtime.RequiredError('verificationRequestId','Required parameter requestParameters.verificationRequestId was null or undefined when calling verifyCustomer.');
        }

        if (requestParameters.verificationCode === null || requestParameters.verificationCode === undefined) {
            throw new runtime.RequiredError('verificationCode','Required parameter requestParameters.verificationCode was null or undefined when calling verifyCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/registration/{verificationRequestId}/verification`.replace(`{${"verificationRequestId"}}`, encodeURIComponent(String(requestParameters.verificationRequestId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerificationCodeToJSON(requestParameters.verificationCode),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerificationResponseFromJSON(jsonValue));
    }

    /**
     * verify new customer
     * verify new customer
     */
    async verifyCustomer(requestParameters: VerifyCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerificationResponse> {
        const response = await this.verifyCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
